var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobsAppliedIonc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 31.412,
    viewBox: "0 0 38 31.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase_2313642",
    transform: "translate(0.341 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39795",
    "data-name": "Path 39795",
    d: "M19.157,9.172a1.594,1.594,0,0,1-1.594-1.594V5.188H11.188V7.578A1.594,1.594,0,1,1,8,7.578V5.188A3.191,3.191,0,0,1,11.188,2h6.375a3.191,3.191,0,0,1,3.188,3.188V7.578A1.594,1.594,0,0,1,19.157,9.172Z",
    transform: "translate(4.436 0)",
    fill: "#23b5d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39796",
    "data-name": "Path 39796",
    d: "M19.96,17.613a3.192,3.192,0,0,1-1.115.191,3.4,3.4,0,0,1-1.209-.223L0,11.62V23.781a4.349,4.349,0,0,0,4.319,4.383H33.372a4.349,4.349,0,0,0,4.319-4.383V11.62Z",
    transform: "translate(-0.341 5.247)",
    fill: "#23b5d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39797",
    "data-name": "Path 39797",
    d: "M37.69,9.383v3.65L19.222,19.281a1.146,1.146,0,0,1-.754,0L0,13.033V9.383A4.349,4.349,0,0,1,4.319,5H33.372A4.349,4.349,0,0,1,37.69,9.383Z",
    transform: "translate(-0.032 1.688)",
    fill: "#23b5d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsAppliedIonc);
export default __webpack_public_path__ + "static/media/jobs_applied_ionc.51746f26549e2849edca19d51f96e0b7.svg";
export { ForwardRef as ReactComponent };